import { toast } from 'react-hot-toast';

type ToastType = 'success' | 'error' | 'info' | 'loading';

interface ToastOptions {
  type?: ToastType;
  duration?: number;
}

export const showToast = (
  message: string,
  typeOrOptions?: ToastType | ToastOptions
) => {
  let type: ToastType | undefined;
  let duration = 3000;

  if (typeof typeOrOptions === 'string') {
    type = typeOrOptions;
  } else if (typeof typeOrOptions === 'object') {
    type = typeOrOptions.type;
    duration = typeOrOptions.duration || 3000;
  }

  const commonOptions = {
    duration,
    style: {
      borderRadius: '8px',
      background: '#333',
      color: '#fff',
    },
  };

  switch (type) {
    case 'success':
      toast.success(message, commonOptions);
      break;
    case 'error':
      toast.error(message, commonOptions);
      break;
    case 'info':
      toast(message, commonOptions);
      break;
    case 'loading':
      toast.loading(message, commonOptions);
      break;
    default:
      toast(message, commonOptions);
  }
};
